<template>
    <div class="flexible-single-wrapper">
        <div class="hero-background eggshell-mutuelle"></div>

        <div v-if="contentIsLoaded" class="page-content" page-transition-group>
            <article>
                <MatrixFields
                    v-for="(element, indexMatrix) in content.matrixSections.sections"
                    :key="'matrix-section-' + indexMatrix"
                    :matrix="element"
                    :indexMatrix="indexMatrix"
                />
            </article>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex'
// import { getDocById } from '@/firebase/init'

import MatrixFields from '@/components/matrix/matrixFields'

export default {
    name: 'ModeleFlexible',

    components: {
        MatrixFields,
    },

    data() {
        return {
            firestoreContent: [],
        }
    },

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data

                    // Get route hash
                    const hash = this.$route.hash

                    if (hash) {
                        setTimeout(() => {
                            // Scroll to hash
                            const el = document.querySelector(`[data-bs-target="${hash}"]`)
                            if (el) {
                                el.scrollIntoView({ behavior: 'smooth' })
                                el.click()
                            }
                        }, 1000)
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },

    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
}
</script>

<style lang="scss"></style>
